<template>
  <div class="loading-statistic-card">
    <batch-card-skeleton
      v-for="index in 5"
      :key="index"
    />
  </div>
</template>

<script>
import BatchCardSkeleton from '@/components/PrintLabels/Batches/Cards/BatchCardSkeleton'

export default {
  name: 'BatchesListSkeleton',
  components: {
    BatchCardSkeleton
  }
}
</script>

<style lang="scss" scoped>
  @use '@/../static/stylesheets/variables' as *;

  .loading-statistic-card {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax($batch-card-min-w, 1fr));
    gap: 1rem;
    max-height: 361px;
    overflow: hidden;
  }
</style>
